
function kgUpdateVariantMediaGallery(kgVariantId, variant) {
  var allGalleries = document.querySelectorAll('media-gallery');
  allGalleries.forEach(function(gallery) {
    gallery.style.display = 'none';
  });

  var kgCurrentVariantSlider = document.querySelector('media-gallery[data-variant-id="' + kgVariantId + '"]');
  var kgFallBackSlider = document.querySelector('media-gallery.kg-default-fallback-main-slider');
  var mediaWrapper = document.querySelector('.m-product-media--desktop.m-product-media--wrapper');
  var templateLayout = mediaWrapper ? (mediaWrapper.dataset.templateLayout || 'layout-2') : 'layout-2';

  if (kgCurrentVariantSlider) {
    kgCurrentVariantSlider.style.display = 'block';
    if (mediaWrapper) {
      mediaWrapper.className = mediaWrapper.className.replace(/m-product-media--layout-\d+/g, '');
      mediaWrapper.classList.add('m-product-media--layout-2');
    }
  } else if (kgFallBackSlider) {
    kgFallBackSlider.style.display = 'block';
    if (mediaWrapper) {
      mediaWrapper.className = mediaWrapper.className.replace(/m-product-media--layout-\d+/g, '');
      mediaWrapper.classList.add('m-product-media--' + templateLayout);
    }
    if (variant && typeof kgFallBackSlider.setActiveMedia === 'function') {
      kgFallBackSlider.setActiveMedia(variant);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var selectedInput = document.querySelector('input[data-selected-variant]');
  var kgCurrentVariantId = selectedInput ? selectedInput.value : null;
  if (kgCurrentVariantId) {
    var productEl = document.querySelector('[data-product-id]');
    var productId = productEl ? productEl.dataset.productId : null;
    var variant = null;
    if (productId && window._themeProducts && window._themeProducts[productId]) {
      var variants = window._themeProducts[productId].variants;
      if (variants) {
        variant = variants.find(function(v) { return v.id == kgCurrentVariantId; });
      }
    }
    kgUpdateVariantMediaGallery(kgCurrentVariantId, variant);
  }
});

document.addEventListener('variant:changed', function(event) {
  if (event.detail && event.detail.variant) {
    kgUpdateVariantMediaGallery(event.detail.variant.id, event.detail.variant);
  }
});
